<template>
    <div class="swiperContainer">
        <el-carousel trigger="click" class="swiper_cont">
            <el-carousel-item
                style="height:100%"
                v-for="(item, index) in list"
                :key="index"
            >
                <img :src="item.activeIcon" alt="" />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import { getMenuInfo } from "@/utils/fc";
export default {
    props: {},
    data() {
        return {
            list: [{ activeIcon: "" }],
        };
    },
    mounted() {
        this.getData();
    },
    watch: {},
    updated() {},
    methods: {
        async getData() {
            let codes = {
                code1: "index",
                code2: "index:pcSwiper",
            };
            let res = await getMenuInfo(codes);
            if (
                res.menuPositionRelationList &&
                res.menuPositionRelationList.length
            ) {
                this.list = res.menuPositionRelationList;
            }
        },
    },
};
</script>
<style scoped>
/deep/ .el-carousel__container{
  height: 100% !important
}
</style>

<style scope lang="scss">

@import "./index.scss";
</style>


// WEBPACK FOOTER //
// src/components/swiperCont/index.vue